import { useMemo } from 'react'
import useTranslation from 'next-translate/useTranslation'

import useAppSelector from '../../../store/hooks/useAppSelector'
import {
  clientContextCompanyUsersListSelector,
  clientContextCurrentCompanyUserIdSelector,
  clientContextCustomerNameSelector,
} from '../../clientContext/store/clientContextSelectors'
import { PrivateProfileId } from '../constants'
import { ProfileOption } from '../types'

/** The private profile followed by the user's company profiles */
export default function useProfileOptions(): ProfileOption[] {
  const { t } = useTranslation('common')

  const companyUsers = useAppSelector(clientContextCompanyUsersListSelector)
  const currentCompanyUserId = useAppSelector(
    clientContextCurrentCompanyUserIdSelector,
  )
  const customerName = useAppSelector(state =>
    clientContextCustomerNameSelector(state, ''),
  )

  return useMemo(() => {
    const privateHint = customerName || t('identity.privateHint')

    return [
      {
        id: PrivateProfileId,
        name: t('identity.private'),
        hint: privateHint,
        avatarName: privateHint,
        isCompany: false,
        isCurrent: !currentCompanyUserId,
        isVerified: true,
      },
      ...companyUsers.map(companyUser => ({
        id: companyUser.id,
        name: companyUser.companyName,
        hint: t('identity.companyHint'),
        avatarName: companyUser.companyName,
        isCompany: true,
        isCurrent: companyUser.id === currentCompanyUserId,
        isVerified: companyUser.emailVerified,
      })),
    ]
  }, [companyUsers, currentCompanyUserId, customerName, t])
}
